import { CopyIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { EmptyCell } from "@/components/ui/empty-cell";
import { copyToClipboard } from "@/utils/copy-to-clipboard";

interface CopyableCellProps {
	value: string | null | undefined;
	label: string;
}

export function CopyableCell({ value, label }: CopyableCellProps) {
	const { t } = useTranslation();

	if (!value) return <EmptyCell />;

	return (
		<span className="inline-flex items-center gap-1.5">
			<span className="font-mono text-sm">{value}</span>
			<Button
				type="button"
				variant="ghost"
				size="icon"
				className="h-6 w-6"
				onClick={(e) => {
					e.stopPropagation();
					copyToClipboard(value, {
						successMessage: t("common.copied", { label }),
						errorMessage: t("common.copyError"),
					});
				}}
				aria-label={t("common.copy", { label })}
			>
				<CopyIcon className="h-3.5 w-3.5" />
			</Button>
		</span>
	);
}
